import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { ParallaxLayer } from 'react-spring/renderprops-addons'

import ShowMoreCircle from '../images/showMoreCircle.svg'

const Container = styled.article`
  ${tw`max-w-md md:max-w-lg m-auto flex flex-col lg:flex-row-reverse z-50`}
`

const Cover = styled.div`
  ${tw`relative w-full z-10 m-auto`}

  width: 100%;
  transition: 0.2s linear;

  @media screen and (max-width: 1024px) {
    width: calc(100% - 8em);
    margin: 0 4em;
  }

  @media screen and (max-width: 512px) {
    width: calc(100% - 1em);
    margin: 0 0.5em;
  }
`

const MonumentImage = styled(Img)`
  ${tw` w-full shadow-lg mx-4`}
  position: absolute;
  top: 0;
  left: 0;

  z-index: -1;
  height: 500px;
  margin: auto;

  transition: 0.5s linear;
  & > img {
    object-fit: cover !important; // or whatever
    object-position: 0% 0% !important; // or whatever
    font-family: 'object-fit: cover !important; object-position: 0% 0% !important;'; // needed for IE9+ polyfill
  }

  @media screen and (max-width: 512px) {
    width: 80%;
    height: 420px;
  }

  &:after {
    content: '';
    ${tw`w-full h-full absolute pin-t`}
    opacity: 0.15;
    background-color: #78ffae;
  }
`

const MonumentText = styled.div`
  ${tw`my-4 px-12 z-50`}
  color: #444;
`

const MonumentTitle = styled.h1`
  ${tw`text-black font-normal font-serif mb-6`}
`

const MonumentDescription = styled.p`
  ${tw`font-light`}
  color: #444;

  &:before {
    content: '';
    display: inline-block;
    width: 56px;
    height: 2px;
    background-color: #666;
    vertical-align: middle;
    margin-right: 0.5em;
  }
`

const MonumentCounter = styled.div`
  ${tw`absolute  flex font-medium`}
  letter-spacing: -0.07em;
  top: 0.5em;
  left: 0em;
  font-size: 92px;

  color: #fff;

  @media screen and (min-width: 992px) {
    font-size: 130px;
    left: -0.75em;
  }
`

const ShowMore = styled(Link)`
  ${tw`flex items-center absolute w-16 no-underline mb-8`}
  bottom: 1em;
  right: 6em;

  &:hover img {
    transform: rotate(90deg);
  }

  @media screen and (max-width: 992px) {
    right: 10em;
  }
`

const ShowMoreText = styled.p`
  ${tw`font-sans relative whitespace-no-wrap m-0 ml-3 text-2xl font-medium shadow-lg`}
  color: #fff;

  &:hover:after {
    transform: rotateY(180deg);
  }

  &:after {
    ${tw`shadow-md`}
    content: '';
    display: inline-block;
    background-color: #fff;
    width: 170px;
    height: 3px;
    position: absolute;
    bottom: -8px;
    left: 0;
    transition: 0.75s linear;
  }
`

const ShowMoreIcon = styled.img`
  ${tw`shadow-lg`}
  transition: 0.2s linear;
  margin: 0;
  margin-top: 0.75em;
`

const ImageCard = ({ data, index }) => {
  const { areas, title, cover } = data.node.frontmatter

  return (
    <Container>
      <MonumentText>
        <MonumentTitle>{title}</MonumentTitle>
        <MonumentDescription>{areas.join(', ')}</MonumentDescription>
      </MonumentText>
      <Cover>
        <MonumentImage fluid={cover.childImageSharp.fluid} />
        <MonumentCounter>
          <span>0</span>
          <span>0</span>
          <span>{index}</span>
        </MonumentCounter>
        <ShowMore to={`/${data.node.fields.slug}`}>
          <ShowMoreIcon src={ShowMoreCircle} />
          <ShowMoreText>See more</ShowMoreText>
        </ShowMore>
      </Cover>
    </Container>
  )
}

export default ImageCard
